<template>
  <!-- 革命文物 -->
  <div class="page-revolution">
    <div class="g-content-wrap">
      <div class="search-box">
        <el-input ref="myInput" clearable v-model="listQuery.keywords" placeholder="输入关键词搜索" @keyup.enter.native="handleSearch" @input="handleChange" style="width:100%;">
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
          <!-- <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button> -->
        </el-input>

        <!-- <div class="btn-search">搜索</div> -->
        <el-button class="btn-search" type="primary" @click="handleSearch">搜索</el-button>
        <!-- <div class="com-head-search-btns">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div> -->
      </div>
      
      <p class="tips" v-show="dataList.length">约有 <span>{{total}}</span> 个结果</p>
      <div class="list-box g-pad-bottom">
        <div class="item" :class="{'zixun': item.type==='webInformation'}" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="item-box-1" v-if="item.img">
            <h2 class="ell">{{item.typeName}} <i class="el-icon-arrow-right"></i> <span v-html="item.title"></span></h2>
            <div class="g-card-2">
              <div class="pic-box">
                <img v-lazy="item.img" alt="">
              </div>
              <div class="g-border-box white">
                <div class="g-border">
                  <div class="info">
                    <!-- <h2 class="ell">资讯 辽宁省博物馆的馆藏精品</h2> -->
                    <div class="two-ell" v-html="item.text"></div>
                    <!-- <div class="line"></div> -->
                    <!-- <p class="addr">
                      所属单位：{{item.publisher}}
                      <span class="ml-30" v-if="activeVal==='xshy'">时间：{{item.createTime}}</span>
                    </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 没图片的模块 -->
          <div class="item-box-2" v-else>
            <div class="info">
              <h2 class="title ell" v-html="item.title"></h2>
              <span>{{item.typeName}}</span>
            </div>
            <div class="desc two-ell" v-html="item.text"></div>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="g-no-data" v-if="showSearch && dataList.length === 0 && !listLoading">
        <div class="no-data-bg"></div>
        <p class="txt text-center">暂无数据</p>
      </div>
      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
import myCmpLike from '@cmp/my-like'
import cmpSearchDict from '@cmp/search-dict'
export default {
  components: { cmpTab, myCmpLike, cmpSearchDict },
  data() {
    return {
      linkObj: {
        // 导览
        '1': '/museum',
        '2': '/exhibition',
      },
      activeVal: '1',
      tabList: [
        {
          name: '可移动革命文物',
          val: '1'
        },
        {
          name: '不可移动革命文物',
          val: '2'
        }
      ],
      dataList: [],
      listQuery: {
        keywords: '',
        currentPage: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      showSearch: false  // 显示暂无数据
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/webapi/search', {
          ...this.listQuery,
          // keywords: '博物馆'
        })
        .then(res => {
          this.listLoading = false
          this.showSearch = true
          if (res.success) {
            this.dataList = res.result
            this.total = res.page.allRow
            console.log(111, this.dataList)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleChange() {
      this.showSearch = false
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    // 获取头部参数
    getHeadParams(params) {
      console.log(params)
      this.listQuery.currentPage = 1
      this.headParams.name = params.key
      this.headParams.type = params.musenumType
      this.headParams.area = params.city
      this.headParams.year = params.year
      this.getDataList()
    },
    eventTabClick(val) {
      console.log(val)
      this.activeVal = val
      if(val === '1') {
        this.listQuery.size = 9
      } else {
        this.listQuery.size = 8
      }
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetail(item) {
      let routeUrl = ''
      switch(item.type) {
        // 资讯
        case 'webInformation':
          routeUrl = this.$router.resolve({
            path: '/about/detail',
            query: {
              id: item.id
            }
          })
          break
        // 公告
        case 'webNotice':
          routeUrl = this.$router.resolve({
            path: '/notice/detail',
            query: {
              id: item.id
            }
          })
          break
        // 在线课堂
        case 'webCourse':
          window.open(item.video)
          break
        // 数字文物
        case 'BsCollect':
          routeUrl = this.$router.resolve({
            path: '/collect/detail',
            query: {
              id: item.id
            }
          })
          break
        // 文创
        case 'webCulturalcreative':
          routeUrl = this.$router.resolve({
            path: '/creative/detail',
            query: {
              id: item.id
            }
          })
          break
        // 展览
        case 'webExhibition':
          routeUrl = this.$router.resolve({
            path: '/exhibition/detail',
            query: {
              id: item.id
            }
          })
          break
        // 学术
        case 'webScience':
          routeUrl = this.$router.resolve({
            path: '/research/detail',
            query: {
              id: item.id
            }
          })
          break
        // 视频
        case 'webVideo':
          window.open(item.video)
          break
        // 讲堂
        case 'webClassroom':
          routeUrl = this.$router.resolve({
            path: '/research/detail',
            query: {
              id: item.id,
              pageType: '5'
            }
          })
          break
      }
      if( item.type === 'webCourse' || item.type === 'webVideo') {
        return
      }
      window.open(routeUrl .href, '_blank')
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
  },
  created() {
    // this.getDataList()
  },
  mounted(){
    this.$refs.myInput.focus()
  }
}
</script>

<style lang="scss" scoped>
.page-revolution {
  .search-box {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    // /deep/ .el-input {
    //   flex: 1;
    //   font-size: 16px;
    //   .el-input__inner {
    //     height: 64px;
    //     border-color: rgba($color: #312F2E, $alpha: 0.2);
    //     // border-radius: 0;
    //     &:hover,
    //     &:focus {
    //       border-color: $primary;
    //       background: inherit;
    //     }
    //   }
    //   .el-input-group__append {
    //     background-color: $primary;
    //     // border: 1px solid $primary;
    //     border: none;
    //   }
    //   .el-icon-search:before {
    //     color: #fff;
    //   }

    //   // .el-icon-circle-close:before {
    //   //   font-size: 24px;
    //   //   position: absolute !important;
    //   //   top: 15px !important;
    //   //   right: 5px !important;
    //   // }
    // }

    .btn-search {
      width: 236px;
    }
  }

  .tips {
    padding: 40px 0;
    color: rgba($color: #000000, $alpha: 0.7);
    font-size: 18px;
    border-bottom: solid 1px rgba($color: #121100, $alpha: 0.2);
    // span {
    //   color: $primary;
    // }
  }

  .list-box {
    .item {
      padding: 30px 0;
      margin: 0;
      border-bottom: 1px solid rgba($color: #121100, $alpha:0.2);
      cursor: pointer;
      .g-card-2 {
        margin: 0;
      }
      h2 {
        font-size: 18px;
        color: #000000;
        margin-bottom: 20px;
      }
      // &:hover {
      //   h2 {
      //     color: $primary;
      //   }
      // }
      .pic-box {
        img {
          width: 372px;
          height: 210px;
          object-fit: contain;
        }
      }
      .info {
        // font-size: 18px;
        color: rgba($color: #000000, $alpha: 0.9);
      }
      // &.zixun {
      //   .pic-box {
      //     img {
      //       width: 256px;
      //       height: 256px;
      //     }
      //   }
      // }
    }

    .item-box-2 {
      position: relative;
      padding: 10px 0;
      padding-left: 40px;
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:before {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          border: solid 1px $primary;
          border-radius: 100%;
          position: absolute;
        }
        &:before {
          left: 0;
          top: 13px;
        }
        h2 {
          width: 1200px;
          margin-bottom: 0;
        }
        span {
          font-size: 18px;
          color: rgba($color: #000000, $alpha: 0.7);
        }
      }
      .desc {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  // 高亮文字
  /deep/ .searchhit {
    color: $primary;
  }
}
</style>


